<ul [class.ellipsis]="ellipsis()">
  @for (item of data; track item; let i = $index) {
    <li>
      @if (i > 0) {
        <span class="arrow" aria-hidden="true">
          <icon glyph="chevron-right"></icon>
        </span>
      }
      @if (item.link && isMainPage(item.link)) {
        <a (click)="navigateToMainPage()"
          [attr.data-test-id]="'breadcrumbs-link-' + (item?.link === '/' ? 'index' :(item?.link | slugify))">
          {{ 'frontpage.label' | translate }}
        </a>
        }	<!-- item.label -->
        @if (item.link && !isMainPage(item.link)) {
          <a [routerLink]="[item.link]"
            [attr.data-test-id]="'breadcrumbs-link-' + (item?.link === '/' ? 'index' :(item?.link | slugify))">
            {{ item.title | translate }}
          </a>
        }
        @if (!item.link) {
          <span aria-current="page" data-test-id="breadcrumbs-link-current">
            {{ item.title | translate }}
          </span>
        }
      </li>
    }
  </ul>
